module.exports = __webpack_public_path__ + "img/131.10097d27.jpg";